export const handle403Error = (error) => {
  if (error.response && error.response.status === 403) {
    localStorage.removeItem("token");
    window.location.href = "/login";
  }
};
